/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames } from '../CapNames';
import { Orientation } from '../Orientation';
import { PlaneGeometry, MeshBasicMaterial, Mesh, LineSegments, LineBasicMaterial, BufferGeometry, Float32BufferAttribute } from 'three';
/**
 * kinds of floor
 */
export var FloorKind;
(function (FloorKind) {
    FloorKind["CHECKERBOARD"] = "checkerboard";
    FloorKind["WIREFRAME"] = "wireframe";
})(FloorKind || (FloorKind = {}));
/**
 * Capability to add a floor
 */
export class FloorCap {
    static createCheckerboard(data) {
        const segments = data.payload.segments || 100;
        const size = data.payload.size || 1000;
        const geometry = new PlaneGeometry(size, size, segments, segments);
        geometry.rotateX(-Math.PI / 2.0);
        const color = data.payload.color || 0xcccccc;
        const color2 = data.payload.color2 || 0x444444;
        const materialEven = new MeshBasicMaterial({ color: color });
        const materialOdd = new MeshBasicMaterial({ color: color2 });
        const materials = [materialEven, materialOdd];
        for (let x = 0; x < segments; x++) {
            for (let y = 0; y < segments; y++) {
                const i = x * segments + y;
                const j = 2 * i;
                geometry.faces[j].materialIndex = geometry.faces[j + 1].materialIndex = (x + y) % 2;
            }
        }
        return new Mesh(geometry, materials);
    }
    static createWireframe(data) {
        const segments = data.payload.segments || 100;
        const size = data.payload.size || 1000;
        const color = data.payload.color || 0xffffff;
        const step = size / segments;
        const halfSize = size / 2;
        const vertices = [];
        for (let i = 0, k = -halfSize; i <= segments; i++, k += step) {
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
        }
        const geometry = new BufferGeometry();
        geometry.addAttribute('position', new Float32BufferAttribute(vertices, 3));
        const mat = new LineBasicMaterial({ color, linewidth: 2 });
        return new LineSegments(geometry, mat);
    }
    getName() {
        return CapNames.FLOOR;
    }
    call(objectIn, sceneIn) {
        const { payload } = objectIn;
        if (payload.floor) {
            const obj = (payload.floor === 'wireframe') ? FloorCap.createWireframe(objectIn) : FloorCap.createCheckerboard(objectIn);
            obj.userData.imaginary = true;
            Orientation.set(obj, objectIn);
            obj.name = objectIn.name;
            sceneIn.add(obj);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=FloorCap.js.map